/** Ikon kanal/media Font Awesome — pengganti emoji. */
export const CH_ICON: Record<string, string> = {
  twitter: "fa-brands fa-x-twitter", instagram: "fa-brands fa-instagram", facebook: "fa-brands fa-facebook",
  tiktok: "fa-brands fa-tiktok", youtube: "fa-brands fa-youtube", blog: "fa-solid fa-blog",
  forum: "fa-solid fa-comments", other: "fa-solid fa-globe",
  news_online: "fa-solid fa-newspaper", print: "fa-regular fa-newspaper", tv: "fa-solid fa-tv", radio: "fa-solid fa-radio",
};
export function Ch({ t, color }: { t: string; color?: string }) {
  return <i className={CH_ICON[t] ?? "fa-solid fa-globe"} style={{ width: 16, textAlign: "center", color }} title={t} />;
}
